webpackJsonp([213],{

/***/ 1216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PositionCheckDetail_vue__ = __webpack_require__(2928);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34cd4f1f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PositionCheckDetail_vue__ = __webpack_require__(5226);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PositionCheckDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34cd4f1f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PositionCheckDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1381);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1352);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1382), __esModule: true };

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1383);


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(146);
var ITERATOR = __webpack_require__(22)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 2070:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return searchRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  up_date: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择发布时间段', 'string'))],
  industry_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择行业大类', 'integer'))],
  position_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择职业类型', 'integer'))],
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入岗位名称', 'string'))],
  employer_name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入发布单位', 'string'))],
  hire_number: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入招聘人数', 'integer')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入大于0的整数', 'integer'), { min: 1 })],
  address: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入工作地点', 'string'))],
  employer_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入发布单位', 'string'))],
  position_period: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择工作时间', 'string'))],
  working_shifts: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择工作班次', 'string'))],
  working_hours: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入工作时长', 'number'))],
  gender: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择性别要求', 'integer'))],
  certificate: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入证件要求', 'string'))],
  working_experience: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入工作经验', 'string'))],

  salary: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入基本薪资', 'integer'))],
  salary_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择薪资方式', 'integer'))],
  settlement_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入结算方式', 'integer'))],
  settlement_time: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择结算时间', 'integer'))],
  area_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择区', 'integer'))]
};

/***/ }),

/***/ 2928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__position_rules_js__ = __webpack_require__(2070);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchRules: __WEBPACK_IMPORTED_MODULE_2__position_rules_js__["a" /* searchRules */],
      checkPassVisible: true, // true表示审核通过,false表示审核不通过
      creator: this.$route.query.creator,
      passDialogVisible: false,
      failDialogVisible: false,
      id: this.$route.params.id,
      errorFields: {
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: null,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        proof: null,
        contactto: null
      },
      inputErrorFields: {
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: null,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        proof: null,
        contactto: null
      },
      // searchRules,
      form: {
        up_date: null,
        down_date: null,
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: 0,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        status: null,
        province_name: null,
        city_name: null,
        area_name: null,
        email: null,
        proof: [],
        contactto: null
      },
      checkForm: {
        userid: null,
        realname: null,
        level: null,
        currentstatus: null,
        current_location: [],
        cellphone: null,
        registertime: null,
        balance: 0,
        frozenbalance: 0,
        totalwithdraw: 0,
        frozenpoints: 0,
        points: 0,
        spendpoints: 0
      },
      options: {
        industry_type: [],
        salary: [],
        position_type: [],
        salary_type: [],
        gender: [],
        settlement_type: [],
        settlement_time: [],
        education: [],
        marriage: [],
        insurance: [],
        level: [],
        currentstatus: [],
        errorMessage: [{ value: 1, label: '选项选择有误' }, { value: 2, label: '未按要求填写内容' }, { value: 3, label: '内容填写有误' }, { value: 4, label: '请详细描述信息内容' }, { value: 5, label: '其他（手动填写）' }]
      },
      dialogVisible: {
        industry_type: false,
        position_type: false,
        title: false,
        hire_number: false,
        address: false,
        employer_name: false,
        position_period: false,
        working_shifts: false,
        working_hours: false,
        gender: false,
        age_range: false,
        certificate: false,
        education: false,
        marriage: false,
        working_experience: false,
        other_requirements: false,
        salary: false,
        salary_type: false,
        commission: false,
        quarterly_bonus: false,
        insurance: false,
        overtime_pay: false,
        meal_allowance: false,
        commute_allowance: false,
        phone_allowance: false,
        welfare: false,
        settlement_type: false,
        settlement_time: false,
        proof: false,
        contactto: false
      }
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    var _this = this;

    request.all.page([request('getPostionForm', this.id), request('editPostionOptions'), request('getUserDetail', this.creator), request('getUserRelatedOptions'), request('getUserCredit', this.creator), request('getUserPoints', this.creator)]).then(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 6),
          postionForm = _ref2[0],
          postionOptions = _ref2[1],
          userDetail = _ref2[2],
          relatedOptions = _ref2[3],
          userCredit = _ref2[4],
          userPoints = _ref2[5];

      (function (_ref3) {
        var data = _ref3.data;

        filter.setLoop(_this.form, data);
      })(postionForm);(function (_ref4) {
        var data = _ref4.data;

        filter.setLoop(_this.options, data);
      })(postionOptions);(function (_ref5) {
        var data = _ref5.data;

        filter.setLoop(_this.checkForm, data);
      })(userDetail);(function (_ref6) {
        var data = _ref6.data;

        filter.setLoop(_this.options, data);
      })(relatedOptions);(function (_ref7) {
        var data = _ref7.data;

        filter.setLoop(_this.checkForm, data);
      })(userCredit);(function (_ref8) {
        var data = _ref8.data;

        filter.setLoop(_this.checkForm, data);
      })(userPoints);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getPostionForm', 'editPostionOptions', 'passAuditPosition', 'failAuditPosition', 'getUserDetail', 'getUserRelatedOptions', 'getUserCredit', 'getUserPoints']), {
    onPassAuditPosition: function onPassAuditPosition() {
      var _this2 = this;

      return request.common('passAuditPosition', this.id).then(function (data) {
        _this2.passDialogVisible = false;
        _this2.$router.push({ path: '/position/pending-audit-table' });
      });
    },
    onFailAuditPosition: function onFailAuditPosition() {
      var _this3 = this;

      var errorFields = [];
      for (var key in this.errorFields) {
        console.log(this.errorFields);
        if (this.errorFields[key] !== null) {
          if (this.errorFields[key] === 5) {
            errorFields.push({ field: key, message: this.inputErrorFields[key] });
          } else {
            for (var i = 0; i < this.options.errorMessage.length; i++) {
              if (this.errorFields[key] === this.options.errorMessage[i].value) {
                errorFields.push({ field: key, message: this.options.errorMessage[i].label });
              }
            }
          }
        }
      }
      var detail = {
        position_id: this.id,
        errorFields: errorFields
      };
      return request.common('failAuditPosition', detail).then(function (data) {
        _this3.failDialogVisible = false;
        _this3.$router.push({ path: '/position/pending-audit-table' });
      });
    },
    showErrorMessage: function showErrorMessage(name) {
      this.dialogVisible[name] = true;
    },
    onSelectErrorMessage: function onSelectErrorMessage(name) {
      if (this.checkPassVisible === true) {
        this.checkPassVisible = false;
      }
    },
    removeErrorMessage: function removeErrorMessage(name) {
      this.dialogVisible[name] = false;
      this.errorFields[name] = null;
      for (var value in this.dialogVisible) {
        if (this.dialogVisible[value] === true) {
          return false;
        }
      }
      this.checkPassVisible = true;
    },
    onClearErrorMessage: function onClearErrorMessage(name) {
      this.errorFields[name] = null;
      for (var value in this.errorFields) {
        if (this.errorFields[value] !== null) {
          return false;
        }
      }
      this.checkPassVisible = true;
    }
  })
});

/***/ }),

/***/ 5226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("招聘管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/position/detail/'+_vm.id}}},[_vm._v("职位列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.searchRules,"label-width":"120px","size":"mini"}},[_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("基本信息")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"industry_type","label":"发布时间:"}},[_c('span',[_vm._v(_vm._s(_vm.form.up_date)+"~"+_vm._s(_vm.form.down_date))])]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"industry_type","label":"行业大类:"}},[_vm._l((_vm.options.industry_type),function(industryType){return (industryType.id === _vm.form.industry_type)?_c('span',[_vm._v("\n            "+_vm._s(industryType.keyword)+"\n          ")]):_vm._e()}),_vm._v("\n              \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('industry_type')}}})],2),_vm._v(" "),(_vm.dialogVisible.industry_type)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('industry_type')},"clear":function($event){return _vm.onClearErrorMessage('industry_type')}},model:{value:(_vm.errorFields.industry_type),callback:function ($$v) {_vm.$set(_vm.errorFields, "industry_type", $$v)},expression:"errorFields.industry_type"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.industry_type === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.industry_type),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "industry_type", $$v)},expression:"inputErrorFields.industry_type"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.industry_type)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('industry_type')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"position_type","label":"职位类型:"}},[_vm._l((_vm.options.position_type),function(positionType){return (positionType.id === _vm.form.position_type)?_c('span',[_vm._v("\n            "+_vm._s(positionType.keyword)+"\n          ")]):_vm._e()}),_vm._v("\n              \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('position_type')}}})],2),_vm._v(" "),(_vm.dialogVisible.position_type)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('position_type')},"change":function($event){return _vm.onSelectErrorMessage('position_type')}},model:{value:(_vm.errorFields.position_type),callback:function ($$v) {_vm.$set(_vm.errorFields, "position_type", $$v)},expression:"errorFields.position_type"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.position_type === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.position_type),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "position_type", $$v)},expression:"inputErrorFields.position_type"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.position_type)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('position_type')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"title","label":"岗位名称:"}},[_vm._v(_vm._s(_vm.form.title)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('title')}}})]),_vm._v(" "),(_vm.dialogVisible.title)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('title')},"change":function($event){return _vm.onSelectErrorMessage('title')}},model:{value:(_vm.errorFields.title),callback:function ($$v) {_vm.$set(_vm.errorFields, "title", $$v)},expression:"errorFields.title"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.title === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.title),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "title", $$v)},expression:"inputErrorFields.title"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.title)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('title')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"hire_number","label":"招聘人数:"}},[_vm._v(_vm._s(_vm.form.hire_number)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('hire_number')}}})]),_vm._v(" "),(_vm.dialogVisible.hire_number)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('hire_number')},"change":function($event){return _vm.onSelectErrorMessage('hire_number')}},model:{value:(_vm.errorFields.hire_number),callback:function ($$v) {_vm.$set(_vm.errorFields, "hire_number", $$v)},expression:"errorFields.hire_number"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.hire_number === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.hire_number),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "hire_number", $$v)},expression:"inputErrorFields.hire_number"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.hire_number)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('hire_number')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"address","label":"工作地点:"}},[_vm._v(_vm._s(_vm.form.province_name)+"-"+_vm._s(_vm.form.city_name)+"-"+_vm._s(_vm.form.area_name)+"       \n          "+_vm._s(_vm.form.address)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('address')}}})]),_vm._v(" "),(_vm.dialogVisible.address)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('address')},"change":function($event){return _vm.onSelectErrorMessage('address')}},model:{value:(_vm.errorFields.address),callback:function ($$v) {_vm.$set(_vm.errorFields, "address", $$v)},expression:"errorFields.address"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.address === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.address),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "address", $$v)},expression:"inputErrorFields.address"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.address)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('address')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"employer_name","label":"发布单位:"}},[_vm._v(_vm._s(_vm.form.employer_name)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('employer_name')}}})]),_vm._v(" "),(_vm.dialogVisible.employer_name)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('employer_name')},"change":function($event){return _vm.onSelectErrorMessage('employer_name')}},model:{value:(_vm.errorFields.employer_name),callback:function ($$v) {_vm.$set(_vm.errorFields, "employer_name", $$v)},expression:"errorFields.employer_name"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.employer_name === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.employer_name),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "employer_name", $$v)},expression:"inputErrorFields.employer_name"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.employer_name)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('employer_name')}}}):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("职位描述")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"position_period","label":"工作时间:"}},[_vm._v(_vm._s(_vm.form.position_period)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('position_period')}}})]),_vm._v(" "),(_vm.dialogVisible.position_period)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('position_period')},"change":function($event){return _vm.onSelectErrorMessage('position_period')}},model:{value:(_vm.errorFields.position_period),callback:function ($$v) {_vm.$set(_vm.errorFields, "position_period", $$v)},expression:"errorFields.position_period"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.position_period === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.position_period),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "position_period", $$v)},expression:"inputErrorFields.position_period"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.position_period)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('position_period')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"working_shifts","label":"工作班次:"}},[_vm._v(_vm._s(_vm.form.working_shifts)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('working_shifts')}}})]),_vm._v(" "),(_vm.dialogVisible.working_shifts)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('working_shifts')},"change":function($event){return _vm.onSelectErrorMessage('working_shifts')}},model:{value:(_vm.errorFields.working_shifts),callback:function ($$v) {_vm.$set(_vm.errorFields, "working_shifts", $$v)},expression:"errorFields.working_shifts"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.working_shifts === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.working_shifts),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "working_shifts", $$v)},expression:"inputErrorFields.working_shifts"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.working_shifts)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('working_shifts')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"working_hours","label":"工作时长:"}},[_vm._v(_vm._s(_vm.form.working_hours)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('working_hours')}}})]),_vm._v(" "),(_vm.dialogVisible.working_hours)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('working_hours')},"change":function($event){return _vm.onSelectErrorMessage('working_hours')}},model:{value:(_vm.errorFields.working_hours),callback:function ($$v) {_vm.$set(_vm.errorFields, "working_hours", $$v)},expression:"errorFields.working_hours"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.working_hours === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.working_hours),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "working_hours", $$v)},expression:"inputErrorFields.working_hours"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.working_hours)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('working_hours')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"gender","label":"性别要求:"}},[_vm._l((_vm.options.gender),function(gender){return (gender.id === _vm.form.gender)?_c('span',[_vm._v("\n            "+_vm._s(gender.keyword)+"\n          ")]):_vm._e()}),_vm._v("\n              \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('gender')}}})],2),_vm._v(" "),(_vm.dialogVisible.gender)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('gender')},"change":function($event){return _vm.onSelectErrorMessage('gender')}},model:{value:(_vm.errorFields.gender),callback:function ($$v) {_vm.$set(_vm.errorFields, "gender", $$v)},expression:"errorFields.gender"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.gender === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.gender),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "gender", $$v)},expression:"inputErrorFields.gender"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.gender)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('gender')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"age_range","label":"年龄要求:"}},[_vm._v(_vm._s(_vm.form.age_range)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('age_range')}}})]),_vm._v(" "),(_vm.dialogVisible.age_range)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('age_range')},"change":function($event){return _vm.onSelectErrorMessage('age_range')}},model:{value:(_vm.errorFields.age_range),callback:function ($$v) {_vm.$set(_vm.errorFields, "age_range", $$v)},expression:"errorFields.age_range"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.age_range === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.age_range),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "age_range", $$v)},expression:"inputErrorFields.age_range"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.age_range)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('age_range')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"certificate","label":"证件要求:"}},[_vm._v(_vm._s(_vm.form.certificate)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('certificate')}}})]),_vm._v(" "),(_vm.dialogVisible.certificate)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('certificate')},"change":function($event){return _vm.onSelectErrorMessage('certificate')}},model:{value:(_vm.errorFields.certificate),callback:function ($$v) {_vm.$set(_vm.errorFields, "certificate", $$v)},expression:"errorFields.certificate"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.certificate === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.certificate),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "certificate", $$v)},expression:"inputErrorFields.certificate"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.certificate)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('certificate')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"education","label":"学历要求:"}},[_vm._l((_vm.options.education),function(education){return (education.id === _vm.form.education)?_c('span',[_vm._v("\n            "+_vm._s(education.keyword)+"\n          ")]):_vm._e()}),_vm._v("\n              \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('education')}}})],2),_vm._v(" "),(_vm.dialogVisible.education)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('education')},"change":function($event){return _vm.onSelectErrorMessage('education')}},model:{value:(_vm.errorFields.education),callback:function ($$v) {_vm.$set(_vm.errorFields, "education", $$v)},expression:"errorFields.education"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.education === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.education),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "education", $$v)},expression:"inputErrorFields.education"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.education)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('education')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"marriage","label":"婚姻状况:"}},[_vm._l((_vm.options.marriage),function(marriage){return (marriage.id === _vm.form.marriage)?_c('span',[_vm._v("\n            "+_vm._s(marriage.keyword)+"\n          ")]):_vm._e()}),_vm._v("\n              \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('marriage')}}})],2),_vm._v(" "),(_vm.dialogVisible.marriage)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('marriage')},"change":function($event){return _vm.onSelectErrorMessage('marriage')}},model:{value:(_vm.errorFields.marriage),callback:function ($$v) {_vm.$set(_vm.errorFields, "marriage", $$v)},expression:"errorFields.marriage"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.marriage === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.marriage),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "marriage", $$v)},expression:"inputErrorFields.marriage"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.marriage)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('marriage')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"working_experience","label":"工作经验:"}},[_vm._v(_vm._s(_vm.form.working_experience)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('working_experience')}}})]),_vm._v(" "),(_vm.dialogVisible.working_experience)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('working_experience')},"change":function($event){return _vm.onSelectErrorMessage('working_experience')}},model:{value:(_vm.errorFields.working_experience),callback:function ($$v) {_vm.$set(_vm.errorFields, "working_experience", $$v)},expression:"errorFields.working_experience"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.working_experience === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.working_experience),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "working_experience", $$v)},expression:"inputErrorFields.working_experience"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.working_experience)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('working_experience')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"other_requirements","label":"补充说明:"}},[_vm._v(_vm._s(_vm.form.other_requirements)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('other_requirements')}}})]),_vm._v(" "),(_vm.dialogVisible.other_requirements)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},on:{"clear":function($event){return _vm.onClearErrorMessage('other_requirements')},"change":function($event){return _vm.onSelectErrorMessage('other_requirements')}},model:{value:(_vm.errorFields.other_requirements),callback:function ($$v) {_vm.$set(_vm.errorFields, "other_requirements", $$v)},expression:"errorFields.other_requirements"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.other_requirements === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.other_requirements),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "other_requirements", $$v)},expression:"inputErrorFields.other_requirements"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.other_requirements)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('other_requirements')}}}):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("薪资福利")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"salary","label":"基本薪资:"}},[_vm._l((_vm.options.salary),function(salary){return (salary.id === _vm.form.salary)?_c('span',[_vm._v(_vm._s(salary.keyword))]):_vm._e()}),_vm._v(" "),_vm._l((_vm.options.salary_type),function(salaryType){return (salaryType.id === _vm.form.salary_type)?_c('span',[_vm._v("\n            "+_vm._s(salaryType.keyword)+"\n          ")]):_vm._e()}),_vm._v("\n              \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('salary')}}})],2),_vm._v(" "),(_vm.dialogVisible.salary)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('salary')}},model:{value:(_vm.errorFields.salary),callback:function ($$v) {_vm.$set(_vm.errorFields, "salary", $$v)},expression:"errorFields.salary"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.salary === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.salary),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "salary", $$v)},expression:"inputErrorFields.salary"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.salary)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('salary')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"提成机制:"}},[_vm._v(_vm._s(_vm.form.commission)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('commission')}}})]),_vm._v(" "),(_vm.dialogVisible.commission)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('commission')}},model:{value:(_vm.errorFields.commission),callback:function ($$v) {_vm.$set(_vm.errorFields, "commission", $$v)},expression:"errorFields.commission"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.commission === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.commission),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "commission", $$v)},expression:"inputErrorFields.commission"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.commission)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('commission')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"quarterly_bonus","label":"季度奖金:"}},[_vm._v(_vm._s(_vm.form.quarterly_bonus)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('quarterly_bonus')}}})]),_vm._v(" "),(_vm.dialogVisible.quarterly_bonus)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('quarterly_bonus')}},model:{value:(_vm.errorFields.quarterly_bonus),callback:function ($$v) {_vm.$set(_vm.errorFields, "quarterly_bonus", $$v)},expression:"errorFields.quarterly_bonus"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.quarterly_bonus === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.quarterly_bonus),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "quarterly_bonus", $$v)},expression:"inputErrorFields.quarterly_bonus"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.quarterly_bonus)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('quarterly_bonus')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"insurance","label":"社保缴纳:"}},[_vm._l((_vm.options.insurance),function(insurance){return (insurance.id === _vm.form.insurance)?_c('span',[_vm._v("\n            "+_vm._s(insurance.keyword)+"\n          ")]):_vm._e()}),_vm._v("\n              \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('insurance')}}})],2),_vm._v(" "),(_vm.dialogVisible.insurance)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('insurance')}},model:{value:(_vm.errorFields.insurance),callback:function ($$v) {_vm.$set(_vm.errorFields, "insurance", $$v)},expression:"errorFields.insurance"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.insurance === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.insurance),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "insurance", $$v)},expression:"inputErrorFields.insurance"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.insurance)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('insurance')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"overtime_pay","label":"加班补助:"}},[_vm._v(_vm._s(_vm.form.overtime_pay)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('overtime_pay')}}})]),_vm._v(" "),(_vm.dialogVisible.overtime_pay)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('overtime_pay')}},model:{value:(_vm.errorFields.overtime_pay),callback:function ($$v) {_vm.$set(_vm.errorFields, "overtime_pay", $$v)},expression:"errorFields.overtime_pay"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.overtime_pay === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.overtime_pay),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "overtime_pay", $$v)},expression:"inputErrorFields.overtime_pay"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.overtime_pay)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('overtime_pay')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"meal_allowance","label":"餐饮补助:"}},[_vm._v(_vm._s(_vm.form.meal_allowance)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('meal_allowance')}}})]),_vm._v(" "),(_vm.dialogVisible.meal_allowance)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('meal_allowance')}},model:{value:(_vm.errorFields.meal_allowance),callback:function ($$v) {_vm.$set(_vm.errorFields, "meal_allowance", $$v)},expression:"errorFields.meal_allowance"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.meal_allowance === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.meal_allowance),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "meal_allowance", $$v)},expression:"inputErrorFields.meal_allowance"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.meal_allowance)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('meal_allowance')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"commute_allowance","label":"交通补助:"}},[_vm._v(_vm._s(_vm.form.commute_allowance)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('commute_allowance')}}})]),_vm._v(" "),(_vm.dialogVisible.commute_allowance)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('commute_allowance')}},model:{value:(_vm.errorFields.commute_allowance),callback:function ($$v) {_vm.$set(_vm.errorFields, "commute_allowance", $$v)},expression:"errorFields.commute_allowance"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.commute_allowance === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.commute_allowance),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "commute_allowance", $$v)},expression:"inputErrorFields.commute_allowance"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.commute_allowance)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('commute_allowance')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"phone_allowance","label":"话费补助:"}},[_vm._v(_vm._s(_vm.form.phone_allowance)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('phone_allowance')}}})]),_vm._v(" "),(_vm.dialogVisible.phone_allowance)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('phone_allowance')}},model:{value:(_vm.errorFields.phone_allowance),callback:function ($$v) {_vm.$set(_vm.errorFields, "phone_allowance", $$v)},expression:"errorFields.phone_allowance"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.phone_allowance === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.phone_allowance),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "phone_allowance", $$v)},expression:"inputErrorFields.phone_allowance"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.phone_allowance)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('phone_allowance')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"welfare","label":"其他福利:"}},[_vm._v(_vm._s(_vm.form.welfare)+"     \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('welfare')}}})]),_vm._v(" "),(_vm.dialogVisible.welfare)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('welfare')}},model:{value:(_vm.errorFields.welfare),callback:function ($$v) {_vm.$set(_vm.errorFields, "welfare", $$v)},expression:"errorFields.welfare"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.welfare === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.welfare),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "welfare", $$v)},expression:"inputErrorFields.welfare"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.welfare)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('welfare')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"settlement_type","label":"结算方式:"}},[_vm._l((_vm.options.settlement_type),function(settlementType){return (settlementType.id === _vm.form.settlement_type)?_c('span',[_vm._v("\n            "+_vm._s(settlementType.keyword)+"\n          ")]):_vm._e()}),_vm._v("\n              \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('settlement_type')}}})],2),_vm._v(" "),(_vm.dialogVisible.settlement_type)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('settlement_type')}},model:{value:(_vm.errorFields.settlement_type),callback:function ($$v) {_vm.$set(_vm.errorFields, "settlement_type", $$v)},expression:"errorFields.settlement_type"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.settlement_type === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.settlement_type),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "settlement_type", $$v)},expression:"inputErrorFields.settlement_type"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.settlement_type)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('settlement_type')}}}):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"settlement_time","label":"结算时间:"}},[_vm._l((_vm.options.settlement_time),function(settlementTime){return (settlementTime.id === _vm.form.settlement_time)?_c('span',[_vm._v("\n            "+_vm._s(settlementTime.keyword)+"\n          ")]):_vm._e()}),_vm._v("\n              \n          "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('settlement_time')}}})],2),_vm._v(" "),(_vm.dialogVisible.settlement_time)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('settlement_time')}},model:{value:(_vm.errorFields.settlement_time),callback:function ($$v) {_vm.$set(_vm.errorFields, "settlement_time", $$v)},expression:"errorFields.settlement_time"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.settlement_time === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.settlement_time),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "settlement_time", $$v)},expression:"inputErrorFields.settlement_time"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.settlement_time)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('settlement_time')}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.checkForm,"label-width":"80px","size":"mini"}},[_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("审核信息")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"用户id:"}},[_vm._v(_vm._s(_vm.checkForm.userid))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"用户真名:"}},[_vm._v(_vm._s(_vm.checkForm.realname))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"用户等级:"}},_vm._l((_vm.options.level),function(value){return (value.id === _vm.checkForm.level)?_c('span',[_vm._v("\n              "+_vm._s(value.keyword)+"\n            ")]):_vm._e()}),0)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"当前状态:"}},_vm._l((_vm.options.currentstatus),function(value){return (value.id === _vm.checkForm.currentstatus)?_c('span',[_vm._v("\n              "+_vm._s(value.keyword)+"\n            ")]):_vm._e()}),0)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"所在地:"}},[_vm._v(_vm._s(_vm.checkForm.current_location.system))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"手机号:"}},[_vm._v(_vm._s(_vm.checkForm.cellphone))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"电子邮箱:"}},[_vm._v(_vm._s(_vm.form.email))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"注册时间:"}},[_vm._v(_vm._s(_vm.checkForm.registertime))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"赏金信息:"}},[_vm._v("可提现金额: "+_vm._s(_vm.checkForm.balance)+" 冻结金额: "+_vm._s(_vm.checkForm.frozenbalance)+" 已提现金额:\n            "+_vm._s(_vm.checkForm.totalwithdraw)+"\n          ")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"零豆信息:"}},[_vm._v("积分总数: "+_vm._s(_vm.checkForm.points)+"     冻结积分:\n            "+_vm._s(_vm.checkForm.frozenpoints)+"     已花费积分: "+_vm._s(_vm.checkForm.spendpoints)+"\n          ")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"图片证据:"}},[_vm._l((_vm.form.proof),function(value){return _c('span',[(value)?_c('a',{attrs:{"href":value,"target":"_Blank"}},[_c('img',{staticStyle:{"border-radius":"50px"},attrs:{"src":value+'?x-oss-process=image/resize,w_100/auto-orient,1',"width":"100px;","height":"100px;"}})]):_vm._e()])}),_vm._v(" "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('proof')}}})],2),_vm._v(" "),(_vm.dialogVisible.proof)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('proof')}},model:{value:(_vm.errorFields.proof),callback:function ($$v) {_vm.$set(_vm.errorFields, "proof", $$v)},expression:"errorFields.proof"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.proof === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.proof),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "proof", $$v)},expression:"inputErrorFields.proof"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.proof)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('proof')}}}):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"联系电话:"}},[_vm._v(_vm._s(_vm.form.contactto)+"\n            "),_c('i',{staticClass:"el-icon-circle-plus",on:{"click":function($event){return _vm.showErrorMessage('contactto')}}})]),_vm._v(" "),(_vm.dialogVisible.contactto)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function($event){return _vm.onSelectErrorMessage('contactto')}},model:{value:(_vm.errorFields.contactto),callback:function ($$v) {_vm.$set(_vm.errorFields, "contactto", $$v)},expression:"errorFields.contactto"}},_vm._l((_vm.options.errorMessage),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.errorFields.contactto === 5)?_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"请输入审核不通过原因","maxlength":20},model:{value:(_vm.inputErrorFields.contactto),callback:function ($$v) {_vm.$set(_vm.inputErrorFields, "contactto", $$v)},expression:"inputErrorFields.contactto"}}):_vm._e(),_vm._v(" "),(_vm.dialogVisible.contactto)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeErrorMessage('contactto')}}}):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"发布单位:"}},[_vm._v("\n            "+_vm._s(_vm.form.employer_name)+"\n          ")])],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"text-align":"center"}},[_c('Br'),_vm._v(" "),_c('router-link',{attrs:{"to":'/position/pending-audit-update/'+_vm.id+'?creator='+_vm.creator}},[_c('el-button',[_vm._v("修改职位信息")])],1),_vm._v(" "),_c('el-button',{attrs:{"disabled":!_vm.checkPassVisible},on:{"click":function($event){_vm.passDialogVisible = true}}},[_vm._v("审核通过\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.checkPassVisible},on:{"click":function($event){_vm.failDialogVisible = true}}},[_vm._v("审核不通过\n      ")]),_vm._v("\n          \n      "),_c('router-link',{attrs:{"to":{ path: '/position/pending-audit-table'}}},[_c('el-button',[_vm._v("返回")])],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.passDialogVisible,"width":"30%","center":""},on:{"update:visible":function($event){_vm.passDialogVisible=$event}}},[_c('span',[_vm._v("审核通过后，该职位到上线时间会自动上线，请确认操作。")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onPassAuditPosition()}}},[_vm._v("确认")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.passDialogVisible = false}}},[_vm._v("取 消")])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.failDialogVisible,"width":"30%","center":""},on:{"update:visible":function($event){_vm.failDialogVisible=$event}}},[_c('span',[_vm._v("审核不通过后，该职位将退还给招聘方,请确认操作。")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onFailAuditPosition()}}},[_vm._v("确认")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.failDialogVisible = false}}},[_vm._v("取 消")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/213.3d8b978bbd9e80927f54.js